<template>
  <div>
    <el-dialog
      :visible.sync="isOpen"
      :close-on-click-modal="false"
      :before-close="ww"
    >
      <div class="dialog-content">
        <el-dialog
          width="30%"
          title="内层 Dialog"
          class="neiceng"
          :visible.sync="dialogVisible"
          append-to-body
          :before-close="handleClose"
          :close-on-click-modal="false"
        >
          <img
            src="../../assets//HelloWorld//tankuang111.png"
            alt=""
            style="width: 114px; height: 112px; padding: 32px 0 16px"
          />
          <div class="xxx_top">提交成功 ！</div>
          <div class="xxx_topy">我们会尽快安排专属人员为您服务~</div>
          <div class="xxx_topu">
            <div class="xxx_topu22" @click="dialogVisibleTOP()">知道了</div>
          </div>
        </el-dialog>
        <div class="boss_2">免费获取行业解决方案</div>
        <div class="boss_3">已有 5187 家企业获取方案</div>
        <div class="boss_4" style="margin-top: 40px">
          <el-select
            v-model="value"
            :popper-append-to-body="false"
            filterable
            placeholder="请选择想了解的行业"
            style="width: 100%; border-radius: 4px"
          >
            <el-option
              v-for="item in schooList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
          <div v-if="yanzheng2" class="errortext">请选择想了解的行业！</div>
        </div>
        <div class="boss_4">
          <el-input
            type="text"
            v-model.trim="input"
            placeholder="请输入联系电话"
            class="boss_41"
          />
          <div v-if="yanzheng" class="errortext">请正确填写联系方式！</div>
        </div>
        <div class="boss_5">提交即可获取30天免费试用</div>
        <div
          style="
            width: 100%;
            display: flex;
            justify-content: center;
            margin-top: 10px;
          "
        >
          <div class="boss_6" @click="dianhuan()">提交</div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { add, getIndustryList } from '@/api/util'
export default {
  props: {
    isOpen: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      open: this.isOpen,
      // isOpen: false,
      dialogVisible: false,
      value: '',
      input: '',
      schooList: [],
      yanzheng2: false,
      yanzheng: false,
    }
  },
  watch: {
    isOpen(newVal) {
      this.watchIsOpen(newVal)
      if (newVal == false) {
        if (this.$getCookie('changjin')) {
          this.$removeCookie('changjin')
        }
      }
    },
  },
  mounted() {
    this.getIndustryListTop()
  },
  methods: {
    ww() {
      this.$emit('update:isOpen', false)
    },
    watchIsOpen(newVal) {
      this.$emit('update:isOpen', newVal) // 将新的 isOpen 值传递给父组件的更新函数
    },
    getIndustryListTop() {
      let that = this
      getIndustryList().then((res) => {
        let arr = []
        for (let i in res.data.data) {
          arr.push(res.data.data[i])
        }
        arr.map((item, index) => {
          that.schooList.push({ label: item.title, value: item.id })
        })
      })
    },
    handleClose(done) {
      this.$confirm('确定取消吗？')((ok) => {
        if (ok) {
          done()
        } else {
          this.dialogVisible = true
        }
      })
    },
    dialogVisibleTOP() {
      this.$emit('update:isOpen', false)
      this.dialogVisible = false
    },
    dianhuan() {
      const ccc =
        /^[1](([3][0-9])|([4][0,1,4-9])|([5][0-3,5-9])|([6][2,5,6,7])|([7][0-8])|([8][0-9])|([9][0-3,5-9]))[0-9]{8}$/
      if (!this.value) {
        this.yanzheng2 = true
      } else if (!ccc.test(this.input)) {
        this.yanzheng2 = false
        this.yanzheng = true
      } else {
        this.yanzheng = false
        let data = {
          phone: this.input,
          industryId: this.value,
          uuid: this.$getItem('result'),
        }
        if (this.$getCookie('changjin')) {
          data.scene = this.$getCookie('changjin')
        }
        console.log(data)
        add(data).then((res) => {
          if (res.data.code == 200) {
            this.input = ''
            this.value = ''
            this.dialogVisible = true
            if (this.$getCookie('changjin')) {
              this.$removeCookie('changjin')
            }
          } else {
            this.input = ''
            this.value = ''
            this.outerVisible = false
          }
          console.log(res)
        })
      }
    },
  },
}
</script>
<style lang="scss" scoped>
::v-deep .el-dialog__headerbtn .el-dialog__close {
  font-size: 40px;
}

::v-deep .el-input__inner {
  height: 60px;
  line-height: 60px;
  font-size: 18px;
}

::v-deep .el-link--inner {
  width: 100%;
  display: flex;
  justify-content: center;
}

::v-deep .el-carousel__container {
  // height: 57vh;
  height: calc(100vw + 100vw * 0.0133);
}

::v-deep .el-link--inner {
  width: 100%;
}

::v-deep .el-carousel__indicators--horizontal {
  bottom: 20%;
}

::v-deep .el-dialog__body {
  padding: 40px 60px;
}

.neiceng ::v-deep .el-dialog {
  //  width:470px !important ;
  //  height: 320px !important;
  border-radius: 8px;
}

.neiceng ::v-deep .el-dialog__header {
  display: none;
}

.neiceng ::v-deep .el-dialog__body {
  text-align: center;
  padding: 0 0 25px;
}

.neiceng .xxx_top {
  height: 28px;
  font-size: 20px;
  font-weight: bold;
  color: #eb5b05;
  margin-bottom: 12px;
}

.neiceng .xxx_topy {
  height: 22px;
  font-size: 16px;
  font-weight: 500;
  color: #666666;
  margin-bottom: 16px;
}

.neiceng .xxx_topu {
  display: flex;
  justify-content: center;
  height: 40px;
}

.neiceng .xxx_topu22 {
  width: 270px;
  cursor: pointer;
  height: 40px !important;
  background: #eb5b05;
  border-radius: 4px;
  height: 28px;
  font-size: 20px;
  font-weight: 500;
  line-height: 40px;
  color: #ffffff;
}

::v-deep .el-dialog {
  border-radius: 10px;
  width: 30%;
}

//   ::v-deep .el-dialog__header{
//     display: none;
//   }
.boss_2 {
  color: #000;
  font-size: 30px;
  font-weight: 00;
  // margin-top: 20px;
  // line-height: 30px;
  text-align: center;
}

.boss_3 {
  align-items: center;
  color: #666666;
  /* -ms-flex-direction: row; */
  flex-direction: row;
  font-size: 18px;
  height: 22px;
  display: flex;
  justify-content: center;
  margin-top: 24px;

  .boss_31 {
    background: #0075ff;
    border-radius: 4px;
    color: #fb6904;
    font-size: 16px;
    font-weight: 500;
    margin: 0 7px;
    padding: 3px 7px;
  }
}

.boss_5 {
  // margin: 2px 36px 0;
  color: #fb6904;
  font-size: 17px;
  // height: px;
  line-height: 28px;
}

.boss_6 {
  cursor: pointer;
  text-align: center;
  line-height: 50px;
  background: #eb6215;
  border-radius: 10px;
  cursor: pointer;
  color: #fff;
  font-size: 21px;
  // cursor: pointer !important;
  font-weight: 500;
  height: 50px;
  width: 60%;
}

.errortext {
  color: #ee1c46;
  font-size: 16px;
  height: 40px;
  width: 100%;
  line-height: 21px;
}

.boss_4 {
  height: 100px;
}
</style>
